import Link from 'next/link';
import { MakerMarketplaceLogo } from './MakerMarketplaceLogo';

type MakerMarketplaceLogoLinkProps = {
  href?: string;
  height?: number;
};

export function MakerMarketplaceLogoLink({
  href = '/',
  height = 48,
}: MakerMarketplaceLogoLinkProps) {
  return (
    <Link
      href={href}
      style={{
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        lineHeight: 0,
      }}
    >
      <MakerMarketplaceLogo height={height} />
    </Link>
  );
}
